import { useState, useCallback, useEffect } from "react";
import EditBusiness from "../components/EditBusiness";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import DeleteModal from "../components/DeleteBusiness";
import { BUSINESS, businessTypes } from "../utils/constants";
import { useCollection } from "react-firebase-hooks/firestore";
import { Loader } from "../hooks/useLoading";
import { Timestamp, getDoc, updateDoc } from "firebase/firestore";
import { adminAuthQuery, contentQuery } from "../utils/queryHelpers";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../contextProvider/contentTypeProvider";
import { getKeysDoc } from "../utils/firestoreHelpers";

const BusinessPage = () => {
  const { contextState, updateContextState } = useMyContext();
  // console.log("contextState :: ", contextState);
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState(
    contextState?.business?.status || "Active"
  );
  const [dialogType, setDialogType] = useState("Add");
  const [type, setType] = useState(contextState?.business?.type || "news");
  const date = new Date();
  const todayTimestamp = Timestamp.fromDate(
    new Date(date.getFullYear(), date.getMonth(), date.getDate())
  );
  const [time, setTime] = useState(todayTimestamp);

  const [keySnapshot, loading1] = useCollection(adminAuthQuery(), {
    snapshotListenOptions: {
      includeMetadataChanges: true,
    },
  });

  const [snapshot, loading, error] = useCollection(
    contentQuery({ status, time, type }),
    {
      snapshotListenOptions: {
        includeMetadataChanges: true,
      },
    }
  );

  const onDeleteModalClose = useCallback(() => {
    setShowDeleteModal(false);
    setSelected(null);
  }, []);
  // console.log(error);

  let authCode = keySnapshot?.docs?.at(0)?.data()?.password_reset_code;

  useEffect(() => {
    const checkAuthStatus = async () => {
      if (loading1 || !keySnapshot?.docs?.length) return;

      let authDetail = JSON.parse(localStorage.getItem("auth_detail"));
      // Do not force logout during refresh if local auth metadata is unavailable.
      if (!authDetail?.code) return;

      if (!authDetail?.checked) {
        let docId = keySnapshot?.docs?.at(0)?.id;
        const docRef = getKeysDoc(docId);
        await getDoc(docRef);
        localStorage.setItem(
          "auth_detail",
          JSON.stringify({ ...authDetail, checked: true })
        );
        updateDoc(docRef, {
          password_reset_code: authDetail?.code,
        });
      } else {
        let docId = keySnapshot?.docs?.at(0)?.id;
        const docRef = getKeysDoc(docId);
        const docDocument = await getDoc(docRef);
        const docData = docDocument?.data();
        if (docData?.password_reset_code !== authDetail?.code) {
          localStorage.setItem("auth_detail", JSON.stringify({}));
        }
      }
    };

    checkAuthStatus();
  }, [authCode, loading1, keySnapshot]);

  return (
    <>
      <header className="d-flex  justify-content-between mb-3">
        <h4>Business</h4>
        <div className="d-flex gap-2">
          <select
            value={type}
            onChange={(e) => {
              updateContextState({
                business: { type: e.target.value, status },
              });
              setType(e.target.value);
            }}
            name="type"
            required
          >
            {businessTypes.map(({ label, value }) => (
              <option value={value} key={value}>
                {label}
              </option>
            ))}
          </select>
          <select
            className="form-control"
            value={status}
            onChange={(e) => {
              updateContextState({
                business: { type, status: e.target.value },
              });
              setStatus(e.target.value);
              setTime(todayTimestamp);
            }}
          >
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
          </select>
          <Button
            variant="dark"
            onClick={() => {
              setShowEditModal(true);
              setDialogType("Add");
            }}
          >
            Add
          </Button>
        </div>
      </header>
      <main className="d-flex gap-1 flex-wrap">
        {loading && <Loader />}
        {error ? (
          <p className="text-error">
            There is some error. Please try again later
          </p>
        ) : null}
        {snapshot?.docs.length < 1 ? (
          <p className="text-center flex-fill"> No Data Available</p>
        ) : null}
        {snapshot?.docs.map((data) => {
          const d = { ...data.data(), id: data.id };
          return (
            <Card style={{ width: "18rem" }} key={d.id}>
              <Card.Img
                variant="top"
                src={d.image_url}
                style={{
                  width: "100%",
                  height: "150px",
                  objectFit: "contain",
                }}
                className="bg-dark"
              />
              <Card.Body>
                <Card.Title>{d.title}</Card.Title>
                <Card.Text>
                <a
                  href={d.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary text-decoration-underline"
                >
                  {d.link}
                </a>
              </Card.Text>
              </Card.Body>
              <Card.Footer className="d-flex gap-2">
                {type !== "news" ? (
                  <Button
                    variant="secondary"
                    onClick={() => {
                      navigate(`${d.id}`);
                    }}
                  >
                    View
                  </Button>
                ) : null}
                <Button
                  variant="primary"
                  onClick={() => {
                    setSelected(d);
                    setShowEditModal(true);
                    setDialogType("Edit");
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="danger"
                  onClick={() => {
                    setSelected(d);
                    setShowDeleteModal(true);
                  }}
                >
                  Delete
                </Button>
              </Card.Footer>
            </Card>
          );
        })}
      </main>
      {showEditModal ? (
        <EditBusiness
          onClose={() => {
            setShowEditModal(false);
            setSelected(null);
          }}
          newType={type}
          prevData={selected}
          dialogType={dialogType}
          setDialogType={setDialogType}
        />
      ) : null}
      {showDeleteModal ? (
        <DeleteModal
          onClose={onDeleteModalClose}
          data={selected}
          type={BUSINESS}
        />
      ) : null}
    </>
  );
};

export default BusinessPage;
